module.exports = __webpack_public_path__ + "img/Brochures.0749d11b.svg";